 import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { fetchContactInfoQuery, updateContactInfoQuery } from "../../api/contactInfoApi";
 


export const getContactInfo = createAsyncThunk(
  "contactInfo/getContactInfo",
  async ( ) => {

    
        return await fetchContactInfoQuery();
   
  }
);

export const updateContactInfo = createAsyncThunk(
  "contactInfo/updateContactInfo",
  async (updatedContactInfo: { email: string; phone: string; }, { dispatch, rejectWithValue }) => {
    try {
      return await updateContactInfoQuery(updatedContactInfo);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// Contact Info Slice

const contactInfoSlice = createSlice({
  name: "contactInfo",
  initialState: {
    contactInfo: null as any | null,
    status: null as boolean | null,
    msg: "",
    error: null as string | null,
  },
  reducers: {
    resetContactInfoStatus(state) {
      state.status = null;
      state.msg = "";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Contact Info
      .addCase(getContactInfo.fulfilled, (state, action: PayloadAction<any>) => {
        state.status = true;
        state.contactInfo = action.payload.data;
      })
      .addCase(getContactInfo.rejected, (state, action) => {
        state.status = false;
        state.contactInfo = null;
        state.error = action.payload as string;
      })

      // Update Contact Info
      .addCase(updateContactInfo.fulfilled, (state, action: PayloadAction<any>) => {
        state.status = true;
        state.contactInfo = action.payload;
        state.msg = "Contact info updated successfully.";
      })
      .addCase(updateContactInfo.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetContactInfoStatus } = contactInfoSlice.actions; 

export default contactInfoSlice.reducer;